<template>
    <div class="relative">
        <vs-button radius type="border" icon-pack="feather" icon="icon-download" size="small"
                   :style="{position:'absolute', right: '6px', top: '6px', zIndex: 999}"
                   @click="exportData()"></vs-button>
        <i-table v-bind="$props" ref="table"/>
    </div>
</template>

<script>
export default {
    name: 'table-csv',

    props: {
        data: Array,
        columns: Array,
        stripe: Boolean,
        border: Boolean,
        'show-header': () => {
            return {
                type: Boolean,
                default: true
            }
        },
        width: () => {
            return {
                type: Number | String,
                default: 'auto'
            }
        },
        height: Number | String,
        'max-height': Number | String,
        loading: Boolean,
        'disabled-hover': Boolean,
        'highlight-row': Boolean,
        'row-class-name': Function,
        size: String,
        'no-data-text': String,
        'no-filtered-data-text': String,
        draggable: Boolean,
        'tooltip-theme ': String,
        'row-key': String
    },

    methods: {
        exportData () {
            const dataCsv = [];
            this.data.forEach(row => {
                const newRow = {};
                this.columns.forEach((coluna, index) => {
                    if (row[coluna.key]) {
                        newRow[coluna.title] = row[coluna.key].toString().replace(/,/g, " ").replace(/\n+/, " ");
                    } else {
                        newRow[`Coluna ${index}`] = " ";
                    }
                });
                dataCsv.push(newRow);
            });
            this.$refs.table.exportCsv({
                filename: 'Export',
                data: dataCsv,
                columns: this.columns
            })
        }
    },
}
</script>

<style lang="sass" scoped>

</style>
